__turbopack_context__.v({
  "helios-data-table": "wVju2a_helios-data-table",
  "helios-data-table-fade-end": "wVju2a_helios-data-table-fade-end",
  "helios-data-table-fade-start": "wVju2a_helios-data-table-fade-start",
  "helios-data-table__caption": "wVju2a_helios-data-table__caption",
  "helios-data-table__cell--end": "wVju2a_helios-data-table__cell--end",
  "helios-data-table__frame": "wVju2a_helios-data-table__frame",
  "helios-data-table__table": "wVju2a_helios-data-table__table",
  "helios-data-table__visually-hidden": "wVju2a_helios-data-table__visually-hidden",
});
